// extracted by mini-css-extract-plugin
export default {"links":"profileLinks_links__LGA+j","link":"profileLinks_link__j-TKK","labelledLink":"profileLinks_labelledLink__0PXoh"};